import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/inquiryCode",
    name: "inquiryCode",
    component: dashboard,
    redirect: {
      name: "baseDataXT"
    },
    children: [
      {
        path: "baseDataXT",
        name: "baseDataXT",
        meta: { title: "线体数据查询查询" },
        component: () => import("@/views/product/inquiryCode/baseDataXT.vue"),
        children: []
      }
    ]
  }
];
